<div class="fx-col page-padding page-content fx-gap-20">
  <app-crud-table title="SUB-LEASES"
                  subTitle="A list of this lease's current sub-leases"
                  [modelType]="leaseSummaryModel"
                  [loading$]="loading$"
                  [tableData]="subLeases">
  </app-crud-table>


  <div class="upload-container">
    @if (parentLease) {
      <div class="fx-row fx-center fx-space-between fx-gap-10">
        <app-csv-import #csvImport
                        [uploadDataModel]="uploadConfig"
                        [disableUpload]="disableUpload"
                        [validateFile]="true"
                        [validateEndpoint]="validateEndpoint"
                        [uploadEndpoint]="uploadEndpoint"
                        (dataValidated)="updateDataAfterValidation($event)"
                        (dataUploaded)="updateAfterUpload($event)">
        </app-csv-import>
      </div>
    }
  </div>
</div>
